module.exports = __webpack_public_path__ + "img/elice_6.0741b939.svg";